import React from 'react';

import { Avatar, Col } from '../../node_modules/antd';
import styled from '../../node_modules/styled-components';

type PropType = {
    showWarningIcon?: boolean;
    amountWarning?: number;
    title: string;
    showLineBreak: boolean;
}

type StateType = {
};


class StatusWarning extends React.Component<PropType, StateType> {

    state: StateType = {
    }

    constructor(props: any) {
        super(props);
    }

    render() {
        const {
            title,
            amountWarning,
            showLineBreak
        } = this.props;
        const {
        } = this.state;
        return (
            <Wrapper>
                <div>
                    <WarningWrapper>
                        <Col>
                            <Avatar style={{ backgroundColor: '#D93838' }} icon="exclamation" />
                        </Col>
                        <Col>
                            <span>{!!amountWarning && (amountWarning)} {title}</span>
                        </Col>
                    </WarningWrapper>
                    {showLineBreak == true && (<div className={"goepik-component-padding"}><hr /></div>)}
                </div>
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`
    .title2{
        font-weight: bold;
    }
    .title3{
        font-weight: bold;
    }
    hr{
        opacity: 0.4;
    }
`;


const WarningWrapper = styled.div`
    font-size:18px;
    display: flex;
    padding-left: 16px;

    div:nth-child(2) {
        padding-left: 26px;
        padding-top: 5px;
    }
`;

export default StatusWarning;